<div *ngIf="selectedGifter" class="gifter-detail-overlay">
    <div class="gifter-detail-container">
      <div class="gifter-detail-content">
        <div class="detail-item" *ngIf="selectedGifterInfo?.name">
          <label>Tên:</label>
          <span>{{ selectedGifterInfo?.name }}</span>
        </div>
        <div class="detail-item" *ngIf="selectedGifterInfo?.organize">
          <label>Tổ chức:</label>
          <span>{{ selectedGifterInfo.organize }}</span>
        </div>
        <div class="detail-userMenu" *ngIf="selectedGifterInfo.menu && selectedGifterInfo.menu.length">
          <ul>
            <li *ngFor="let item of selectedGifterInfo.menu">{{ item }}</li>
          </ul>
        </div>
      <div class="gifter-detail-footer">
        <button class="btn-primary" (click)="close.emit()">
          Đóng
        </button>
      </div>
    </div>
  </div>
</div>  